import { render, staticRenderFns } from "./ItemTitle.vue?vue&type=template&id=50356301&scoped=true"
import script from "./ItemTitle.vue?vue&type=script&lang=js"
export * from "./ItemTitle.vue?vue&type=script&lang=js"
import style0 from "./ItemTitle.vue?vue&type=style&index=0&id=50356301&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50356301",
  null
  
)

export default component.exports